import { createTrackingUtils } from "../index";
import useProfiler from "../../../hooks/useProfiler";
import { useEffect } from "react";

const utils = createTrackingUtils({
  name: "flights_web_sr_gen_ai_summary_v3_mdot",
  stages: {
    direct: 2,
    meta: 3,
    us: 4,
    nonUs: 5,
    shortHaul: 6,
    mediumHaul: 7,
    longHaul: 8,
    children: 9
  },
  goals: {
    sortAndFilterClick: 1,
    summaryClick: 2,
    loading: 3,
    success: 4,
    error: 5
  },
  defaultStage: 1
});

const useTrackStages = (isEligible: boolean) => {
  const { stages } = utils;
  const { isDirect, isMeta, isAmerican, isWithKids, isShortHaul, isMediumHaul, isLongHaul } = useProfiler();

  useEffect(() => {
    if (!isEligible) {
      return;
    }

    isDirect() && stages.direct();
    isMeta() && stages.meta();
    isAmerican() ? stages.us() : stages.nonUs();

    isShortHaul() && stages.shortHaul();
    isMediumHaul() && stages.mediumHaul();
    isLongHaul() && stages.longHaul();

    isWithKids() && stages.children();
  }, [isEligible, stages, isDirect, isMeta, isAmerican, isWithKids, isShortHaul, isMediumHaul, isLongHaul]);
};

export default { ...utils, useTrackStages };
